var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-view__box"},[_c('team'),_c('pay'),_c('sign'),_c('weapon')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }